import { regExps } from '$constants'

/**
 * Validates and transforms a textfield number value
 * @param newValue the value to be validated
 * @param onlyPostiveNumbers the onlyPositiveNumbers flag
 * @returns Validated and transformed value
 */
export const transformTextFieldNumberOnChange = (
  newValue: string,
  onlyPostiveNumbers: boolean | undefined
): string => {
  //This prevents the user to insert more than one dot in the input
  if (regExps.multipleDotsPattern.test(newValue) && newValue.endsWith('.')) {
    newValue = newValue.slice(0, -1)
  }

  // This prevents negative numbers if the onlyPostiveNumbers flag is set
  if (onlyPostiveNumbers && newValue.startsWith('-')) {
    newValue = newValue.slice(1)
  }

  return newValue
}
